
export const Contact = () => {

    return (
        <>Contact.</>
    );

}